import React, { useEffect } from 'react';
import { GuideType } from '../../types';
import { useActiveGuide } from '../../queries/guides';
import { useThemesetByGuideId } from '../../queries/themesets';

export const useHideMainHeader = (isHeaderHidden: boolean) => {
  const { data: activeGuide } = useActiveGuide();
  const { data: theme } = useThemesetByGuideId(activeGuide?.id);

  React.useEffect(() => {
    const observer = new MutationObserver((_mutationsList, observer) => {
      const mainHeader = document.getElementById('mainHeader');
      if (isHeaderHidden && mainHeader) {
        mainHeader.style.display = 'none';
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      const mainHeader = document.getElementById('mainHeader');
      if (mainHeader) mainHeader.style.display = 'block';
    };
  }, [isHeaderHidden, theme?.properties?.landingPageHeaderEnabled]);

  return null;
};

export const useDocumentTitle = () => {
  const { data: guide } = useActiveGuide();
  const isMultiPage = guide?.type === GuideType.MULTI_PAGE;
  const prevTitle = document.title;
  useEffect(() => {
    if (isMultiPage) {
      document.title = guide?.title;
    }

    return () => {
      if (isMultiPage) {
        document.title = '';
      }
    };
  }, [guide?.title, isMultiPage, prevTitle]);
};
